export enum TipoInput {
    Texto = 1,
    Select = 2,
    Numero = 3,
    IntervaloNumererico = 4,
    Data = 4,
  }